/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery, useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { categoriesQuery } from "../__generated__/categoriesQuery";
import { useHistory, useLocation } from "react-router";
import { searchCategoryPodcastsQuery, searchCategoryPodcastsQueryVariables } from "../__generated__/searchCategoryPodcastsQuery";
import { Helmet } from "react-helmet";

const CATEGORIES_QUERY = gql`
  query categoriesQuery {
    getCategories {
      ok
      categories {
        id
        name
        slug
        podcasts {
          id
          title
          rating
        }
      }
    }
  }
`;

const SEARCH_CATEGORY_PODCASTS_QUERY = gql`
  query searchCategoryPodcastsQuery($input: SearchPodcastsInput!) {
    searchPodcastsByCategorySlug(input: $input) {
      ok
      error
      totalPages
      totalResults
      podcasts {
        id
        title
        category {
          name
        }
        episodes {
          id
        }
      }
    }
  }
`;

export const Category = () => {
  const [page, setPage] = useState(1);
  const onNextPageClick = () => setPage((current) => current + 1);
  const onPrevPageClick = () => setPage((current) => current - 1);
  const { data } = useQuery<categoriesQuery>(CATEGORIES_QUERY);
  const location = useLocation();
  const history = useHistory();
  const [queryReadyToStart, { data: searchData, loading }] = useLazyQuery<
    searchCategoryPodcastsQuery,
    searchCategoryPodcastsQueryVariables
  >(SEARCH_CATEGORY_PODCASTS_QUERY);

  useEffect(() => {
    const [_, query] = location.search.split("?query=");

    queryReadyToStart({
      variables: {
        input: {
          page: 1,
          query,
        },
      },
    });
  }, [history, location, queryReadyToStart]);

  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Category | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center items-center text-center pt-10">
        <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
          <div className="relative mb-3 mr-auto">
            <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Category</div>
          </div>
          <div className="h-80 relative overflow-scroll">
            <div className="grid grid-cols-2 gap-2">
              {data?.getCategories.categories?.map((category, index) => (
                <Link
                  to={`/category?query=${category.slug}`}
                  key={category.id}
                  style={{ backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16)}` }}
                  className="py-3 rounded-lg hover:opacity-60 transition delay-75 font-bold text-black"
                >
                  <div>{category.name}</div>
                </Link>
              ))}
            </div>
          </div>
          {!loading && (
            <div className="pb-20 mx-auto mt-8 relative w-full">
              {searchData?.searchPodcastsByCategorySlug.podcasts && searchData?.searchPodcastsByCategorySlug.podcasts.length > 0 ? (
                <div>
                  <div className="flex flex-col w-full">
                    {searchData?.searchPodcastsByCategorySlug.podcasts?.map((podcast) => (
                      <Link
                        key={podcast.id}
                        to={`/podcast/${podcast.id}`}
                        className=" text-left break-all w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start hover:bg-gray-800"
                      >
                        <div className="flex flex-col items-start">
                          <div className="py-1 px-2 mb-2 bg-pink-800 rounded-lg text-md">{podcast.category?.name}</div>
                          <div className=" font-bold text-xl text-center tracking-wider mb-2">{podcast.title}</div>
                          <div className="font-semibold text-md text-gray-200 mb-2">
                            Total Episodes: {podcast.episodes ? podcast.episodes.length : 0}
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <div className="grid grid-cols-3 text-center max-w-md items-center mx-auto mt-10">
                    {page > 1 ? (
                      <button onClick={onPrevPageClick} className="focus:outline-none font-medium text-2xl">
                        &larr;
                      </button>
                    ) : (
                      <div></div>
                    )}
                    <span>
                      Page {page} of {searchData?.searchPodcastsByCategorySlug.totalPages}
                    </span>
                    {page !== searchData?.searchPodcastsByCategorySlug.totalPages ? (
                      <button onClick={onNextPageClick} className="focus:outline-none font-medium text-2xl">
                        &rarr;
                      </button>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
